<script lang="ts">
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import { storyblokEditable } from '@storyblok/svelte';
  import LinkedInIcon from '@athena-lib/Icons/LinkedInIcon.svelte';
  import XIcon from '@athena-lib/Icons/XIcon.svelte';
  import FacebookIcon from '@athena-lib/Icons/FacebookIcon.svelte';
  import { getLocalizationContext } from '@athena-lib/i18n';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import clsx from 'clsx';
  import type { BlogPostInfoBlock } from '@storyblok-types';
  import { pageSectionYSpaceCaster } from '@athena-lib/Page/types';
  import { isRichTextEmpty } from '../RichText/types';
  import PageSectionHeading from './shared/PageSectionHeading.svelte';
  import { castAlignment, containerAlignClasses } from './shared/page-section-utils';
  import { getBlogPostContext } from './BlogPostBlok.svelte';

  const { blok }: { blok: BlogPostInfoBlock } = $props();
  const blogPostContext = getBlogPostContext();
  const blogBlok = $derived(blogPostContext?.value);

  const hasTitle = $derived((blogBlok?.title || '').trim() !== '');
  const hasDescription = $derived(!isRichTextEmpty(blogBlok?.preamble));

  const locale = getLocalizationContext();
  const postDate = $derived(
    blogBlok?.dateCreated
      ? new Date(blogBlok.dateCreated).toLocaleDateString(locale.language, {
          day: 'numeric',
          month: 'short',
        })
      : undefined,
  );

  const postYear = $derived(
    blogBlok?.dateCreated
      ? new Date(blogBlok.dateCreated).toLocaleDateString(locale.language, {
          year: 'numeric',
        })
      : undefined,
  );

  const translations = getCommonTranslations();
</script>

<PageSection
  action={storyblokEditable}
  actionArg={blok}
  ySpace={{
    top: pageSectionYSpaceCaster(blok.paddingTop) ?? 'medium',
    bottom: pageSectionYSpaceCaster(blok.paddingBottom) ?? 'medium',
  }}
>
  {#if (hasTitle || hasDescription) && blogBlok}
    <div
      class={clsx(
        'mb-7 flex',
        containerAlignClasses['desktop'][castAlignment(blogBlok.contentAlignment) ?? 'left'],
      )}
    >
      <PageSectionHeading
        allowFullWidthHeading={blogBlok.headingFullWidth}
        headingText={blogBlok.title}
        headingTag={blogBlok.headingTag}
        headingSize={blogBlok.headingSize}
        description={blogBlok.preamble}
        mobileAlignment={blogBlok.mobileTextAlignment}
        desktopAlignment={blogBlok.desktopTextAlignment}
      />
    </div>
  {/if}
  <div class="flex justify-between">
    {#if postDate && postYear}
      <div class="mb-10 font-bold"><span class="text-st-red">{postDate} </span> {postYear}</div>
    {/if}
    <div class="flex gap-6">
      <a href="https://www.facebook.com/StickerApp" aria-label={translations.stickerAppFacebookPage}
        ><FacebookIcon /></a
      >
      <a
        href="https://www.linkedin.com/company/stickerapp"
        aria-label={translations.stickerAppLinkedInPage}><LinkedInIcon /></a
      >
      <a href="https://x.com/StickerApp" aria-label={translations.stickerAppXPage}><XIcon /></a>
    </div>
  </div>
  <hr class="border-2 border-st-gray-800" />
</PageSection>
